import { useTranslation } from "react-i18next";
import "./LanguageChange.scss";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import { setGenreOptionsI18n } from "explorer/reducers/generos";
import { setCountryOptionsI18n } from "explorer/reducers/countries";

const SelectLanguageChange: React.FC = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const { genres } = useSelector((state: any) => state.genres);
  const { countries } = useSelector((state: any) => state.countries);

  const setCountryOptions = useCallback(async () => {
    if (countries) {
      dispatch(setCountryOptionsI18n(i18n.language));
    }
  }, [countries, dispatch, i18n]);

  const setGenreOptions = useCallback(async () => {
    if (genres) {
      dispatch(setGenreOptionsI18n(i18n.language));
    }
  }, [genres, dispatch, i18n]);

  const onChangeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    setGenreOptions();
    setCountryOptions();
  };

  useEffect(() => {
    setCountryOptions();
    setGenreOptions();
  }, [setCountryOptions, setGenreOptions]);

  return (
    <Select
      className="select-language"
      onChange={onChangeLanguage}
      value={i18n?.language}
      showSearch={false}
      popupClassName="select-dropdown"
    >
      <Select.Option value="en">EN</Select.Option>
      <Select.Option value="pt">PT</Select.Option>
      <Select.Option value="es">ES</Select.Option>
    </Select>
  );
};
export default SelectLanguageChange;
